<template>
  <div class="mainChild page-content" id="markingDataStatistics">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item>打标数据统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div v-show="divShow">
      <div class="carlss" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="divLoading">
        加载中
      </div>
    </div>
    <section class="backDiv">
      <div class="title f16" style="font-size: 20px;font-weight: 600;margin: 16px 0 16px 0;">
        <span
          v-for="(item,i) in newPlateList"
          :key="i"
          :class="activeKey == item.dictCode?'active':''"
          @click="navChange(item)"
        >{{item.dictName}}</span>
      </div>
      <section class="seaerch-wrapper" style="padding: 0px;margin: 0px;">
        <el-form class="search-form">
          <el-form-item label="产品信息" :label-width="formLabelWidth">
            <el-cascader
              filterable
              clearable
              size="small"
              v-model="productid"
              :options="options"
              :props="productidChildren"
              collapse-tags
              @change="handleChange"
              @visible-change="getListBybmcid"
              style="width: 100%;"
              :disabled="cascaderDisabled"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="特殊查询" :label-width="formLabelWidth">
            <el-select v-model="valueType" placeholder="请选择" size="small" style="width: 30%;margin-right: 3%;">
              <el-option
                v-for="item in optionType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input
              :clearable="true"
              placeholder="0"
              v-model="price1"
              size="small"
              style="width: 30%;"
              type="number"
            ></el-input>
            <span>
              -
            </span>
            <el-input
              :clearable="true"
              placeholder="1000"
              v-model="price2"
              size="small"
              style="width: 30%;"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="savehcmMarkingdata()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </section>
    <div class="tableClass">
      <div style="width: 100%;height: 420px;overflow-x: scroll;white-space: nowrap;" v-loading="dataLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading">
        <div style="position: absolute;top: 380px;left: 47%;font-size: 18px;color: #ccc;" v-show="this.tableData.length == 0">
          暂无数据
        </div>
        <div id="chartProduct" style="width: 1800px;height: 400px;"></div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%;margin-top: 20px;"
        ref="multipleTable"
        tooltip-effect="dark"
        v-loading="dataLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        :default-sort = "{prop: 'date', order: 'descending'}"
        >
        <el-table-column label="序号" align="left" type="index" width="65" fixed="left">
        </el-table-column>
        <el-table-column prop="productname" label="标记名称" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.productname">
              {{scope.row.productname}}
            </span>
            <span v-else style="color: red;">
              标记名称已过期
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="shopcount" label="店铺数" sortable>
        </el-table-column>
        <el-table-column prop="goodscount" label="商品数量" sortable>
        </el-table-column>
        <el-table-column prop="avgprice" label="均价" sortable>
        </el-table-column>
        <el-table-column prop="minprice" label="最低价" sortable>
        </el-table-column>
        <el-table-column prop="maxprice" label="最高价" sortable>
        </el-table-column>
        <el-table-column prop="totalsales" label="销量" sortable>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import pagination from "../../../components/dataTable/pagination";
  import echarts from 'echarts'
  import axios from "axios";
  export default {
    data() {
      return {
        dataLoading: false,
        asdfg: '',
        formLabelWidth: "100px",

        productid: '',
        productidChildren: {
          multiple: true,
          value: "id",
          label: "productClassifyName",
          children: "children"
        },
        options: [],
        cascaderDisabled: false,
        divLoading: false,
        divShow: false,

        optionType: [{
          value: 1,
          label: '店铺数'
        },{
          value: 2,
          label: '商品数量'
        },{
          value: 3,
          label: '均价'
        },{
          value: 4,
          label: '最低价'
        },{
          value: 5,
          label: '最高价'
        },{
          value: 6,
          label: '销量'
        },],
        valueType: '',
        price1: '',
        price2: '',
        activeKey: '',
        newPlateList: [{
          dictCode: "TBTM",
          dictName: "淘宝天猫",
        },{
          dictCode: "JD",
          dictName: "京东商城",
        },{
          dictCode: "SN",
          dictName: "苏宁易购"
        },{
          dictCode: "PDD",
          dictName: "拼多多"
        },{
          dictCode: "1688",
          dictName: "1688"
        },{
          dictCode: "DD",
          dictName: "当当网"
        }],

        tableData: [],
        pageNo: 1,
        pageSize: 10,
        totalNum: 10,
        currentPage: 1,

        echartsName: [],
      }
    },
    mounted() {

    },
    methods: {
      // 新增
      savehcmMarkingdata() {
        this.dataLoading = true
        let datas = {
          platform: this.activeKey
        }
        fetch({
          url: "hcm/hcmMarkingdata/savehcmMarkingdata",
          method: "post",
          data: datas,
          timeout: 60 * 1000 * 5
        })
        .then(res => {
          console.log(res)
          if (res.data == '查询成功') {
            this.getMarkingdata()
          } else {
            this.$message({
              message: res.data,
              type: 'warning'
            });
          }
        })
      },
      // 新增成功获取数据
      getMarkingdata() {
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          platform: this.activeKey,
        }
        let newProductid = []
        if (this.productid && this.productid.length > 0) {
          for (var a = 0; a < this.productid.length; a++) {
            if (this.productid[a][1]) {
              newProductid.push(this.productid[a][1].split(",")[0])
            }
          }
          if (newProductid.length > 0) {
            params.products = newProductid.join(",")
          }
        }
        if (this.price1) {
          params.price1 = this.price1
        }
        if (this.price2) {
          params.price2 = this.price2
        }
        if (this.valueType) {
          params.type = this.valueType
        }

        fetch({
          url: "hcm/hcmMarkingdata/getMarkingdata",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = []
            this.tableData = res.data.content
            this.totalNum = res.data.totalElements
            this.dataLoading = false
            this.productEcharts()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // echarts
      productEcharts() {
        // 数据处理
        this.echartsName = []
        let Num1 = []
        let Num2 = []
        let Num3 = []
        let Num4 = []
        let Num5 = []
        if (this.tableData.length > 0) {
          for (let a in this.tableData) {
            if (this.tableData[a].productname) {
              this.echartsName.push(this.tableData[a].productname)
              Num1.push(this.tableData[a].shopcount)
              Num2.push(this.tableData[a].goodscount)
              Num3.push(this.tableData[a].avgprice)
              Num4.push(this.tableData[a].minprice)
              Num5.push(this.tableData[a].maxprice)
            }
          }
        }
        this.chartLine = echarts.init(document.getElementById('chartProduct'));
        // 指定图表的配置项和数据
        var posList = [
          'left', 'right', 'top', 'bottom',
          'inside',
          'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
          'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
        ];

        app.configParameters = {
          rotate: {
            min: -90,
            max: 90
          },
          align: {
            options: {
              left: 'left',
              center: 'center',
              right: 'right'
            }
          },
          verticalAlign: {
            options: {
              top: 'top',
              middle: 'middle',
              bottom: 'bottom'
            }
          },
          position: {
            options: echarts.util.reduce(posList, function (map, pos) {
              map[pos] = pos;
              return map;
            }, {})
          },
          distance: {
            min: 0,
            max: 100
          }
        };

        app.config = {
          rotate: 90,
          align: 'left',
          verticalAlign: 'middle',
          position: 'insideBottom',
          distance: 15,
          onChange: function () {
            var labelOption = {
              normal: {
                rotate: app.config.rotate,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                position: app.config.position,
                distance: app.config.distance
              }
            };
            myChart.setOption({
              series: [{
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }]
            });
          }
        };
        var labelOption = {
          show: true,
          position: app.config.position,
          distance: app.config.distance,
          align: app.config.align,
          verticalAlign: app.config.verticalAlign,
          rotate: app.config.rotate,
          formatter: '{c}  {name|{a}}',
          fontSize: 16,
          rich: {
            name: {
              textBorderColor: '#fff'
            }
          }
        };
        var option = {
          color: ['#5470C6', '#FF99FF', '#FAC858', '#EE6666', '#91CC75'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: this.echartsName
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              data: this.echartsName
            }
          ],
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '店铺数',
            type: 'bar',
            barGap: 0,
            label: labelOption,
            data: Num1
          },
          {
            name: '商品数量',
            type: 'bar',
            barGap: 0,
            label: labelOption,
            data: Num2
          },
          {
            name: '均价',
            type: 'bar',
            label: labelOption,
            data: Num3
          },
          {
            name: '最低价',
            type: 'bar',
            label: labelOption,
            data: Num4
          },
          {
            name: '最高价',
            type: 'bar',
            label: labelOption,
            data: Num5
          }]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine.setOption(option);
      },
      //导航切换
      navChange(item) {
        console.log(item)
        this.activeKey = item.dictCode;
        this.pageNo = 1;
        this.pageSize = 10;
        this.currentPage = 0;
        this.productid = '';
        this.valueType = '';
        this.price1 = '';
        this.price2 = '';
        this.savehcmMarkingdata()
      },
      // productid赋值
      handleChange(value) {
        this.productid = value
      },
      // 获取产品信息数据
      getListBybmcid(data) {
        if (data == true && this.options.length == 0) {
          this.divLoading = true
          this.cascaderDisabled = true
          this.divShow = true
          fetch({
            url: "hcm/hcmProduct/getListBybmcid",
            method: "get",
            noFormat: true,
            responseType: "text"
          }).then(res => {
            let result = JSON.parse(res);
            if (result.status == "10000") {
              this.options = result.data;
              this.cascaderDisabled = false
              this.divShow = false
            }
          });
        }
      },
      handleSizeChange(val) {
        //每页
        this.pageSize = val;
        this.savehcmMarkingdata();
      },
      handleCurrentChange(val) {
        //当前页
        this.pageNo = val;
        this.savehcmMarkingdata();
      },

    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
.title {
  text-align: center;
  span {
    padding-left: 33px;
    cursor: pointer;
  }
  .span:hover,
  .active {
    color: #108cee;
  }
}
.backDiv {
  padding: 20px;
  margin-bottom: 10px;
  background-color: white;
}
.carlss {
  width: 163px;
  height: 185px;
  background: white;
  position: absolute;
  top: 142px;
  z-index: 9999;
  left: 96px;
  color: white;
}
.tableClass {
  background-color: white;
  padding: 20px;
}
</style>
<style>
.el-table th {
  background: #f3f7ff;
}
</style>
